export default __webpack_public_path__ + "static/media/pursuit-menu-allresults-off.977bde86.svg";